export default "__VITE_ASSET__Be1w9IQM__"